import React from 'react';
import { useState, useEffect } from "react";
import CharacteristicModal from './../components/CharacteristicModal';
import FolderModal from './../components/FolderModal';
import DeleteModal from './../modal/delete/DeleteModal';
import ModalWrap from "./../modal/ModalWrap";
import Tree from './../components/Tree';

const LibrariesModule = ({ 
  handeleWrapClick,
  modalRef,
  modalRefHeader
}) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const closeModal = () => setModalIsOpen(false);

    const [currentCharacteristic, setCurrentCharacteristic] = useState({ name: '', type: '' });
    const [currentParam, setCurrentParam] = useState({ name: '' });
    const [characteristics, setCharacteristics] = useState([]);

    const [folderModalIsOpen, setFolderModalIsOpen] = useState(false);
    const closeFolderModal = () => setFolderModalIsOpen(false);

    const [folders, setFolders] = useState([]);
    const [folderModalHeader, setFolderModalHeader] = useState('');

    const [selectedId, setSelectedId] = useState(null);
    const [selectedParamId, setSelectedParamId] = useState(null);
    const [selectedParent, setSelectedParent] = useState(null);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isDeleteParamModalOpen, setIsDeleteParamModalOpen] = useState(false);

    const [previousCharacteristic, setPreviousCharacteristic] = useState({ name: '', type: '' });
    const [previousParam, setPreviousParam] = useState({ name: '' });

    const [selectedItems, setSelectedItems] = useState(new Set());

    const [libraryItems, setLibraryItems] = useState([]);
    const [libraryParamItems, setLibraryParamItems] = useState([]);

    const [isCreateLibrary, setIsCreateLibrary] = useState(false);
    const [isCreateParam, setIsCreateParam] = useState(false);

    useEffect(() => {
      getLibraries();
    }, []);

    async function getLibraries() {
      const allLibraries = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/object_params/selectAttachedLib`
      );
      const result = await allLibraries.json();
      setLibraryItems(result);
    }

    const openModal = (isAdd = false) => {
      setIsCreateParam(isAdd);
        if (isAdd) {
          setCurrentParam({ name: '' });
          setFolderModalHeader('Добавить значение');
        }
        else {
          setCurrentParam({ name: previousParam.name });
          setFolderModalHeader('Редактировать справочник');
        }
        setModalIsOpen(true);
      };

    const openFolderModal = (isCreate) => {
      setIsCreateLibrary(isCreate);
        if (isCreate) {
          setCurrentCharacteristic({ name: '', type: '' });
          setFolderModalHeader('Добавить справочник');
        }
        else {
          setCurrentCharacteristic({ name: previousCharacteristic.name, type: previousCharacteristic.type });
          setFolderModalHeader('Редактировать справочник');
        }
         setFolderModalIsOpen(true);
      }  

    const handleCharacteristicSubmit = (plName) => {
      if (isCreateParam) {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertToParamsLib`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({libcode: selectedId, plname: plName})
            })
          .then(response => {
            response.json().then(async response => {
              console.log("Library param was created, id = " + response.id);
              addLibraryParam(response.id, plName, response.id);
              setSelectedParamId(response.id);
              setPreviousParam({ name: plName });
            })
            
          })
          .catch(error => {
                  console.error('Ошибка добавления значения: ', error);
          });
        }
        else {
          console.log('update = ' + selectedParamId + ' ' + plName);
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateParamLib`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({id: selectedParamId, plname: plName})
            })
          .then(response => {
            console.log("Library param updated");
            updateItemParamName(selectedParamId, plName);
          })
          .catch(error => {
                  console.error('Ошибка обновления значения: ', error);
          });
        }
    };

      const handleFolderSubmit = (libName) => {
        if (isCreateLibrary) {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/insertToAttachedLib`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({libname: libName})
            })
          .then(response => {
            response.json().then(async response => {
              console.log("library was created, id = " + response.id);
              addLibraryItem(response.id, libName, response.id);
              setSelectedId(response.id);
              setPreviousCharacteristic({ name: libName });
            })
              
            })
          .catch(error => {
                  console.error('Ошибка создания справочника: ', error);
          });
        }
        else {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/updateAttachedLib`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({libname: libName, id: selectedId})
            })
          .then(response => {
            console.log("librray updated");
            updateItemLibraryName(selectedId, libName);
          })
          .catch(error => {
                  console.error('Ошибка обновления категории: ', error);
          });
        }
      };

      const addLibraryParam = (id, name, parent) => {
        const newItem = {
          id: id,
          name: name,
          parent: parent
        };
        setLibraryParamItems([...libraryParamItems, newItem]);
      };

      const addLibraryItem = (id, name, parent) => {
        const newItem = {
          id: id,
          name: name,
          parent: parent
        };
        setLibraryItems([...libraryItems, newItem]);
      };

      const deleteLibraryParamItem = (id) => {
        const deleteItemRecursively = (id, items) => {
          return items.filter(item => item.id !== id && item.parent !== id);
        };
        setLibraryParamItems(deleteItemRecursively(id, libraryParamItems));
      };

      const deleteLibraryItem = (id) => {
        const deleteItemRecursively = (id, items) => {
          return items.filter(item => item.id !== id && item.parent !== id);
        };
        setLibraryItems(deleteItemRecursively(id, libraryItems));
      };

      const updateItemParamName = (id, newName) => {
        setLibraryParamItems(libraryParamItems.map(item =>
          item.id === id
            ? { ...item, name: newName }
            : item
        ));
      };

      const updateItemLibraryName = (id, newName) => {
        setLibraryItems(libraryItems.map(item =>
          item.id === id
            ? { ...item, name: newName }
            : item
        ));
      };

      const handleSelect = (item) => {
          setSelectedId(item.id);
          setSelectedParamId(null);
          setPreviousCharacteristic({ name: item.name });
          fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/selectParamsLib?libcode=${item.id}`)
          .then(response => response.json())
          .then(data => {
            setLibraryParamItems(data);
          })
          .catch(error => {
            console.error('Ошибка при загрузке данных:', error);
          })
      };

      const handleSelectParam = (item) => {
        setSelectedParamId(item.id);
        setPreviousParam({ name: item.name });
      }

      const openDeleteModal = () => {
        setIsDeleteModalOpen(true);
      };

      const openDeleteParamModal = () => {
        setIsDeleteParamModalOpen(true);
      };

      const handleDelete = () => {
        console.log("Элемент удалён");
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/deleteAttachedLib`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({id: selectedId})
          })
        .then(response => {
          console.log("Library deleted");
          deleteLibraryItem(selectedId);
          setSelectedId(null);
          setLibraryParamItems([]);
          setSelectedParamId(null);
        })
        .catch(error => {
                console.error('Ошибка удаления справочника: ', error);
        });
      };

      const handleDeleteParam = () => {
        console.log("Элемент удалён");
        fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/deleteParamLib`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({id: selectedParamId})
          })
        .then(response => {
          console.log("Library param deleted");
          deleteLibraryParamItem(selectedParamId);
          setSelectedParamId(null);
        })
        .catch(error => {
                console.error('Ошибка удаления значения: ', error);
        });
      };

      const handleToggle = (id, isChecked) => {
        const updatedSelectedItems = new Set(selectedItems);
        if (isChecked) {
          updatedSelectedItems.add(id);
        } else {
          updatedSelectedItems.delete(id);
        }
        setSelectedItems(updatedSelectedItems);
      };

  return (
    <>
      {(
        <div>
         <FolderModal
        isOpen={modalIsOpen}
        onClose={closeModal}
        onSubmit={handleCharacteristicSubmit}
        initialName={currentParam.name}
        headerText={folderModalHeader}
      />
      <ul>
        {characteristics.map((char, index) => (
          <li key={index}>{char.name} ({char.type})</li>
        ))}
      </ul>

      <FolderModal
        isOpen={folderModalIsOpen}
        onClose={closeFolderModal}
        onSubmit={handleFolderSubmit}
        initialName={currentCharacteristic.name}
        headerText={folderModalHeader}
      />
      <ul>
        {folders.map((folder, index) => (
          <li key={index}>{folder}</li>
        ))}
      </ul>
    </div>
      )}
      
        <div className="tools__wrap" onClick={handeleWrapClick}>
<div ref={modalRefHeader} className="content-container">
<div className="button-row">
          
            <div
              className="tool__add__new_info add__buttons"
              onClick={() => openFolderModal(true)}
            >
              Добавить справочник
            </div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedId ? 'disabled' : ''}`}
  onClick={() => {openFolderModal(false)}}
  style={{ 
    cursor: !selectedId ? 'not-allowed' : 'pointer',
    opacity: !selectedId ? 0.5 : 1,
  }}
>
  Редактировать справочник
</div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedId ? 'disabled' : ''}`}
  onClick={() => {openDeleteModal()}}
  style={{ 
    cursor: !selectedId ? 'not-allowed' : 'pointer',
    opacity: !selectedId ? 0.5 : 1,
  }}
>
  Удалить справочник
</div>
<div
  className={`tool__add__new_info add__buttons`}
  onClick={handeleWrapClick}
  id='closeWrap'
>
  Закрыть
</div>
</div>

<div className="button-row">
          
            <div
              className={`tool__add__new_info add__buttons ${!selectedId ? 'disabled' : ''}`}
              onClick={() => openModal(true)}
              style={{ 
                cursor: !selectedId ? 'not-allowed' : 'pointer',
                opacity: !selectedId ? 0.5 : 1,
              }}
            >
              Добавить значение
            </div>

            <div
  className={`tool__add__new_info add__buttons ${!selectedParamId ? 'disabled' : ''}`}
  onClick={() => {
    if (selectedId) {
      if (previousCharacteristic.type == -1) {
        openFolderModal(false);  // Ваше действие на удаление
      }
      else {
        openModal(false);  // Ваше действие на удаление
      }
    }
  }}
  style={{ 
    cursor: !selectedParamId ? 'not-allowed' : 'pointer',
    opacity: !selectedParamId ? 0.5 : 1,
  }}
>
  Редактировать значение
</div>
            <div
  className={`tool__add__new_info add__buttons ${!selectedParamId ? 'disabled' : ''}`}
  onClick={() => {openDeleteParamModal()}}
  style={{ 
    cursor: !selectedParamId ? 'not-allowed' : 'pointer',
    opacity: !selectedParamId ? 0.5 : 1,
  }}
>
  Удалить значение
</div></div>

            </div>

          <div ref={modalRef} className="tool__list__libraries">
          
            {
           <div className="tree-container">
            <div className="tree">
              <h4>Справочники</h4>
              <Tree items={libraryItems} selectedId={selectedId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelect} withCheckboxes={false} />
            </div>

            <div className="tree">
            <h4>Значения справочника</h4>
              <Tree items={libraryParamItems} selectedId={selectedParamId} selectedParent={selectedParent} selectedItems={selectedItems} onToggle={handleToggle} onSelect={handleSelectParam} withCheckboxes={false} />
            </div>
            </div>}
            
          </div>
        </div>
      
      {isDeleteModalOpen && (
        <ModalWrap><DeleteModal
          set={setIsDeleteModalOpen}
          handeleDelete={handleDelete}
          question="Вы уверены, что хотите удалить этот элемент?"
        /></ModalWrap>
      )}
      {isDeleteParamModalOpen && (
        <ModalWrap><DeleteModal
          set={setIsDeleteParamModalOpen}
          handeleDelete={handleDeleteParam}
          question="Вы уверены, что хотите удалить этот элемент?"
        /></ModalWrap>
      )}
    </>
  );
};

export default LibrariesModule;